module.exports = __webpack_public_path__ + "icons.png?f5ededa96d52c17d3a8340d821d14d9a";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons.png
// module id = 849
// module chunks = 0